// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__fvd2Y","list":"TableCells_list__1CHFk","firstItemBold":"TableCells_firstItemBold__R-UNl","link":"TableCells_link__3NIWF"};